
import { FloatingLabel, Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';

import useHijos from "../hooks/useHijos"
import { DeleteIcon, PencilIcon } from '../assets/icons';
import TooltipHover from './TooltilHover';

const HijosComponent = () => {

    const { isOpen, abrirModal, cerrarModal, setFormHijos, formHijos,
        hijos, llenarFormHijo, cargando, borrarHijo, guardarHijos,
        necesitaGuarderia, setNecesitaGuarderia, setTieneHijos, tieneHijos } = useHijos();

    function mostrarInputGuarderia() {
        if ( necesitaGuarderia ) {
            return (
                <FloatingLabel
                    controlId="floatingInput2"
                    label="Guardería"
                    className="mb-3"
                >
                    <Form.Control
                        placeholder=" "
                        autoComplete='off'
                        value={ formHijos.guarderia }
                        onChange={ e => setFormHijos({ ...formHijos, guarderia: e.target.value }) }
                    />
                </FloatingLabel>
            )
        }
    }

    function tablaBoton() {
        if ( tieneHijos ) {
            return (
                <>
                    <Button variant="info" onClick={ abrirModal }>
                        Registrar hijo
                    </Button>

                    <div className='table-responsive my-4'>
                        <Table bordered hover>
                            <thead>
                                <tr>
                                    <th className='text-center'>Edad</th>
                                    <th className='text-center'>Guardería</th>
                                    <th className='text-center'>Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                { hijos.map(( e, i )=> (
                                    <tr key={ i }>
                                        <td className='text-center'>
                                            { e.edad }
                                        </td>
                                        <td className='text-center'>
                                            { (e.guarderia) ? e.guarderia : 'No necesita guardería' }
                                        </td>
                                        <td className='text-center'>
                                            <ButtonGroup>
                                                <TooltipHover tooltipText='Editar información'>
                                                    <Button variant='warning' onClick={ () => llenarFormHijo( e ) }>
                                                        <PencilIcon/>
                                                    </Button>
                                                </TooltipHover>
                                                <TooltipHover tooltipText='Eliminar'>
                                                    <Button variant='danger' onClick={ () => borrarHijo( e.pk_hijo ) }>
                                                        <DeleteIcon/>
                                                    </Button>
                                                </TooltipHover>
                                            </ButtonGroup>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </>
            )
        }
    }

    return (
        <div className="my-4">
            <p className="lead text-center">
                ¿Tiene hijos?
            </p>

            <Form.Check
                id = 'tiene_hijos'
                type = 'checkbox'
                className = 'd-flex justify-content-center no-select'
                checked = { tieneHijos }
                onChange = { e => setTieneHijos( e.target.checked ) }
                label = '&nbsp;&nbsp;Marcar en caso de tenerlos'
            />


            { tablaBoton() }


            <Modal
                centered
                size="xl"
                className=''
                show={ isOpen }
                backdrop="static"
                keyboard={ false }
                onHide={ cerrarModal }
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Administrar registros</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <Alert variant='success'>
                        Complete los siguientes campos.
                    </Alert>

                    <Row>
                        <Col xs={12} xl={6}>
                            <FloatingLabel
                                label="Edad"
                                className="mb-3"
                                controlId="floatingInput3"
                            >
                                <Form.Control
                                    placeholder=" "
                                    autoComplete='off'
                                    value={ formHijos.edad }
                                    onChange={ e => setFormHijos({ ...formHijos, edad: e.target.value }) }
                                />
                            </FloatingLabel>
                            <Form.Check
                                id = 'necesita_guarderia'
                                type = 'checkbox'
                                className = 'd-flex justify-content-center no-select mb-3'
                                checked = { necesitaGuarderia }
                                onChange = { e => setNecesitaGuarderia( e.target.checked ) }
                                label = '&nbsp;&nbsp;Marcar en caso de necesitar guardería'
                            />
                        </Col>
                        <Col xs={12} xl={6}>
                            { mostrarInputGuarderia() }
                        </Col>
                    </Row>

                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={ cerrarModal }>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={ guardarHijos } disabled={ cargando }>
                        { ( cargando ) ? "Guardando" : "Guardar cambios" }
                    </Button>
                </Modal.Footer>
            </Modal>
            <hr className='m-5'/>
        </div>
    )
}

export default HijosComponent
